export const endpoints = {
    auth: {
        check: '/auth/check',
        signup: '/auth/signup',
        exchangeMagicToken: '/auth/exchange-magic-token',
        refresh: '/auth/refresh',
        refreshToken: '/auth/refresh-token',
        logout: '/auth/logout',
        logoutAll: '/auth/logout-all',
        user: '/auth/user',
        invite: '/auth/invite',
    },
    impersonation: {
        exchangeToken: '/impersonation/exchange-token',
        status: '/impersonation/status',
        end: '/impersonation/end',
    },
    feedback: {
        submit: '/feedback/',
    },
    hris: {
        upload: '/csv/upload',
        listJobs: '/csv/jobs',
        jobStatus: '/csv/jobs',
        fieldMappings: '/csv/jobs',
        detailedMappings: '/csv/jobs',
        updateSingleMapping: '/csv/mappings',
        updateAllMappings: '/csv/jobs',
        confirmMappings: '/csv/jobs',
        confirmedMappings: '/csv/jobs',
        jobResults: '/csv/jobs',
        auditTrail: '/csv/jobs',
        fieldMetadata: '/csv/fields/metadata',
        downloadErrors: '/csv/jobs',
        retryFailed: '/csv/jobs',
    },
    notifications: {
        list: '/notifications/',
        dismiss: (id: string) => `/notifications/${id}/dismiss`,
        dismissAll: '/notifications/dismiss-all',
    },
    notificationSettings: {
        get: (userUuid: string) => `/notifications/profiles/users/${userUuid}/preferences/`,
        update: (userUuid: string) => `/notifications/profiles/users/${userUuid}/preferences/`,
    },
    integrations: {
        generateUrl: '/integrations/admin/generate-install-url',
        sendEmail: '/integrations/admin/send-installation-email',
        organizationOverview: '/integrations/overview/organization',
        platformHealth: '/integrations/health',
        platformWorkspaces: '/integrations/platform/{platform}/workspaces',
        platformStats: '/integrations/platform/{platform}/stats',
        resyncPlatform: '/integrations/{platform}/resync',
        platformSyncStatus: '/integrations/{platform}/sync-status',
        disconnect: '/integrations/{platform}/connection',
    },
    intake: {
        validateSurvey: (token: string) => `/surveys/assignments/${token}/`,
        submitSurvey: (token: string) => `/surveys/assignments/${token}/submit/`,
        myAssignments: '/surveys/my-assignments/intake/',
    },
    hrIntake: {
        form: {
            questions: '/hr-intake-form/form/questions/',
            submission: '/hr-intake-form/form/submission/',
            progress: '/hr-intake-form/form/progress/',
            reset: '/hr-intake-form/form/submission/reset/',
        },
    },
    onboarding: {
        status: '/onboarding/status',
    },
    users: {
        list: '/users',
        details: '/users',
        byEmail: '/users/by-email',
        myTeam: '/users/my-team',
        profile: '/users',
        profilePicture: '/users',
    },
    hierarchy: {
        organization: '/organization/hierarchy',
        filters: '/organization/hierarchy/filters',
    },
} as const
